import { render, staticRenderFns } from "./renter.vue?vue&type=template&id=64615b7f&scoped=true&"
import script from "./renter.vue?vue&type=script&lang=js&"
export * from "./renter.vue?vue&type=script&lang=js&"
import style0 from "./renter.vue?vue&type=style&index=0&id=64615b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64615b7f",
  null
  
)

export default component.exports